import { flowMax, SimpleUnchangedProps } from 'ad-hok'
import { addEffectOnMount } from 'ad-hok-utils'
import { addApi } from 'shared/src/api'
import { addOptionalPathParam } from 'shared/src/utils/addNavigate'
import { trackEvent } from 'shared/src/utils/analytics'

import { addLaunchContext } from './launchContext'

const trackSiteVisitEvent = (creatorId: number | null) => {
  trackEvent(
    {
      category: 'general',
      action: 'site_visit',
    },
    {
      creator_id: creatorId ?? undefined,
    }
  )
}

export const addSiteVisitAnalyticsEventFiring: SimpleUnchangedProps = flowMax(
  addOptionalPathParam('username'),
  addApi,
  addLaunchContext,
  addEffectOnMount(({ api, username, hasMountedInitialPage }) => () => {
    if (hasMountedInitialPage) return

    const fireSiteVisitEvent = async () => {
      let creatorId: number | null = null
      try {
        if (username) {
          const userDetails = await api.users.details(username)
          creatorId = userDetails.id
        }
      } finally {
        trackSiteVisitEvent(creatorId)
      }
    }

    fireSiteVisitEvent()
  })
)

export const trackProfileNavigationEvent = (url: string, creatorId: number) => {
  trackEvent(
    {
      category: 'profile',
      action: 'navigate',
    },
    {
      url,
      creator_id: creatorId,
    }
  )
}
